export const LOTTERY_TICKET_TYPES = {
    CHRISTMAS: 'CHRISTMAS',
    WINTER: 'WINTER',
    EASTER: 'EASTER',
    STANDARD: 'STANDARD',
};

export const LOTTERY_TICKET_PRIZES = {
    NORGESBILLETTEN: 'Norgesbilletten',
};

export const getLotteryTicketTypeName = (type) => {
    switch (type) {
        case LOTTERY_TICKET_TYPES.CHRISTMAS:
            return LOTTERY_TICKET_TYPES.CHRISTMAS;
        case LOTTERY_TICKET_TYPES.WINTER:
            return LOTTERY_TICKET_TYPES.WINTER;
        case LOTTERY_TICKET_TYPES.EASTER:
            return LOTTERY_TICKET_TYPES.EASTER;
        case LOTTERY_TICKET_TYPES.STANDARD:
        default:
            return LOTTERY_TICKET_TYPES.STANDARD;
    }
};

export const getRandomPrizeWon = ({ ticketTypesWithPrizes, typeId }) => {
    const prizesForType = ticketTypesWithPrizes.find((p) => p.type_id === typeId)?.prizes;
    return prizesForType?.[Math.floor(Math.random() * prizesForType.length)];
};
